/* eslint-disable import/default */

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import routes from './routes';
import configureStore from './store/configureStore';
require('./favicon.ico'); // Tell webpack to load favicon.ico
import './styles/index.scss'; // Yep, that's right. You can import SASS/CSS files too! Webpack will run the associated loader and plug this into the page.
// import '../node_modules/bootstrap/dist/css/bootstrap.css';
// import '../node_modules/bootstrap/dist/css/bootstrap-theme.css';
import { syncHistoryWithStore } from 'react-router-redux';

// import initial data
import { createUserObject } from './constants/factory';
import RequestData from './data/requests';
import UserData from './data/users';
import Permissions from './data/permissions';

const initialData = {
    requests: RequestData().requests,
    users: UserData().users,
    permissions: Permissions().permissions,
    currentUser: createUserObject('', '', '', '')
};

const store = configureStore(initialData); // Add initial state
// Create an enhanced history that syncs navigation events with the store
const history = syncHistoryWithStore(browserHistory, store);

const router = (
    <Provider store={store}>
        <Router history={history} routes={routes}/>
    </Provider>
);
render(router, document.getElementById('app'));



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/